/** Shape of a successful GET /api/health response. */
export type HealthOk = {
  status: 'ok'
  environment: string
  db: {
    schemaVersion: string
    updatedAt: string
    latencyMs: number
  }
}

export type HealthError = {
  status: 'error'
  error: string
}

export type Health = HealthOk | HealthError

/** Fetches /api/health, turning a non-JSON or failed response into a HealthError. */
export async function fetchHealth(fetchImpl: typeof fetch = fetch): Promise<Health> {
  try {
    const res = await fetchImpl('/api/health')
    const body = (await res.json()) as Health
    if (body && (body.status === 'ok' || body.status === 'error')) return body
    return { status: 'error', error: `unexpected response from /api/health (${res.status})` }
  } catch (err) {
    return { status: 'error', error: err instanceof Error ? err.message : String(err) }
  }
}
